module.exports = __webpack_public_path__ + "static/media/newsletter-december-2018-fundraiser.7434c2fd.jpg";